import { Box, Typography, styled } from "@mui/material";
import nlData from "../../translations/nl/global.json";
import FooterLinks from "./FooterLinks";
import Wrapper from "../layout/Wrapper";
import { useTranslation } from "react-i18next";
import ImageSizingContainer from "../common/ImageSizingContainer";

const Footer = () => {
  const { Pages } = JSON.parse(JSON.stringify(nlData));
  const { t } = useTranslation();

  const navLinks = Object.values(Pages).map((page: any, index: number) =>
    page.page.type === "sub-menu" ? (
      <FooterLinks key={index} page={page} index={index} />
    ) : (
      <Typography key={index} fontSize={13}>
        <Link href={page.page.href}>{page.page.name}</Link>
      </Typography>
    ),
  );

  return (
    <>
      <FooterContainer
        sx={{
          zIndex: 999,
          marginTop: "8rem",
        }}
      >
        <Wrapper>
          <Box
            display={"flex"}
            sx={{
              padding: { xs: "2rem 2rem", md: "3rem 0 2.8rem 0" },
              flexDirection: { xs: "column", md: "row" },
              gap: { md: 26, xs: 5 },
            }}
          >
            <Box display={"flex"} flexDirection={"column"} gap={4.1}>
              <img
                src={require("../../assets/images/logo/logo.png")}
                alt="Logo"
                width="170"
              />
              <Box display={"flex"} flexDirection={"column"} gap={0.3}>
                <Typography
                  variant="h4"
                  letterSpacing={0}
                  fontWeight={"bold"}
                  marginBottom={"1rem"}
                >
                  {t("footer.work_at")}
                </Typography>
                <TypographyResized>
                  <Link href="mailto:support@gohome.rent">
                    support@gohome.rent
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link href="tel:+310853031549">+31 (0)85 303 15 49</Link>
                </TypographyResized>
              </Box>
              <Box display={"flex"} flexDirection={"column"} gap={1.7}>
                <TypographyResized>
                  <Link
                    href={process.env.REACT_APP_WORDPRESS_URL + "/over-ons/"}
                  >
                    {t("footer.about")}
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link
                    href={process.env.REACT_APP_WORDPRESS_URL + "/contact/"}
                  >
                    Contact
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link href={process.env.REACT_APP_WORDPRESS_URL + "/jobs/"}>
                    {t("footer.jobs")}
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL + "/kenniscentrum/"
                    }
                  >
                    {t("footer.knowledge_base")}
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL +
                      "/veelgestelde-vragen/"
                    }
                  >
                    {t("footer.faq")}
                  </Link>
                </TypographyResized>
              </Box>
            </Box>

            <Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={1.7}
                marginBottom={3}
              >
                <Typography
                  variant="h4"
                  letterSpacing={0}
                  fontWeight={"bold"}
                  marginBottom={"1rem"}
                >
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL + "/woning-verhuren/"
                    }
                    sx={{
                      textDecoration: "none",
                      ":hover": {
                        textDecoration: "none",
                      },
                    }}
                  >
                    Woning verhuren
                  </Link>
                </Typography>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL + "/woning-verhuren/"
                    }
                  >
                    Hoe werkt het?
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL +
                      "/huurprijs-berekenen/"
                    }
                  >
                    Huurprijs berekenen
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL +
                      "/puntentelling-huurwoning-2025/"
                    }
                  >
                    Puntentelling
                  </Link>
                </TypographyResized>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL +
                      "/verhuren-aan-expats/"
                    }
                  >
                    Verhuur aan expats
                  </Link>
                </TypographyResized>
              </Box>
              <Box display={"flex"} flexDirection={"column"} gap={1.7}>
                <Typography
                  variant="h4"
                  letterSpacing={0}
                  fontWeight={"bold"}
                  marginBottom={"1rem"}
                >
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL + "/woning-huren/"
                    }
                    sx={{
                      textDecoration: "none",
                      ":hover": {
                        textDecoration: "none",
                      },
                    }}
                  >
                    Woning huren
                  </Link>
                </Typography>
                <TypographyResized>
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL + "/woning-huren/"
                    }
                  >
                    Hoe werkt het?
                  </Link>
                </TypographyResized>
              </Box>
            </Box>

            <Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={1.7}
                marginBottom={3}
              >
                <Typography
                  variant="h4"
                  letterSpacing={0}
                  fontWeight={"bold"}
                  marginBottom={"1rem"}
                >
                  <Link
                    href={
                      process.env.REACT_APP_WORDPRESS_URL + "/woning-verhuren/"
                    }
                    sx={{
                      textDecoration: "none",
                      ":hover": {
                        textDecoration: "none",
                      },
                    }}
                  >
                    Aangesloten bij
                  </Link>
                </Typography>
                <ImageSizingContainer
                  source={require("../../assets/images/pararius_logo.png")}
                  alt="pararius"
                  sx={{
                    width: "9rem",
                    height: "100%",
                  }}
                />
                <ImageSizingContainer
                  source={require("../../assets/images/funda_logo.png")}
                  alt="funda"
                  sx={{
                    width: "6rem",
                    height: "100%",
                  }}
                />
                <ImageSizingContainer
                  source={require("../../assets/images/huurwoningen_logo.png")}
                  alt="huurwoningen"
                  sx={{
                    width: "10rem",
                    height: "100%",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Wrapper>

        <Copyright>
          <Wrapper>
            <Box
              display={"flex"}
              alignItems={"center"}
              alignContent={"center"}
              sx={{
                flexWrap: { xs: "wrap", md: "nowrap" },
                height: { xs: "8rem", md: "8rem" },
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              <CopyrightTypography marginRight={"0.5rem"}>
                Copyrights 2024 - GoHome.rent
              </CopyrightTypography>
              <CopyrightTypography>
                |
                <CopyrightLink
                  href={
                    process.env.REACT_APP_WORDPRESS_URL +
                    "/algemene-voorwaarden"
                  }
                >
                  {t("footer.conditions")}
                </CopyrightLink>
                |
              </CopyrightTypography>
              <CopyrightTypography>
                <CopyrightLink
                  href={process.env.REACT_APP_WORDPRESS_URL + "/privacybeleid"}
                >
                  {t("footer.privacy")}
                </CopyrightLink>
                |
              </CopyrightTypography>
              <CopyrightTypography>
                <CopyrightLink
                  href={process.env.REACT_APP_WORDPRESS_URL + "/cookiebeleid"}
                >
                  Cookies
                </CopyrightLink>
              </CopyrightTypography>
            </Box>
          </Wrapper>
        </Copyright>
      </FooterContainer>
    </>
  );
};

export default Footer;

const FooterContainer = styled(Box)({
  backgroundColor: "#F4F3FB",
  paddingTop: "1.4rem",
  bottom: 0,
  left: 0,
  right: 0,
  borderRadius: "50px 50px 0 0",
});

export const Link = styled("a")({
  color: "#000",
  textDecoration: "none",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
});

const Copyright = styled(Box)({
  backgroundColor: "#F4F3FB",
});

const CopyrightLink = styled(Link)({
  margin: "0 0.45rem",

  "&:hover": {
    color: "#fff",
    textDecoration: "none",
    transition: "0.2s",
  },
});

const CopyrightTypography = styled(Typography)({
  fontSize: 13,
});

const TypographyResized = styled(Typography)({
  fontSize: 13,
});
